import translations from '../core/data/disaster-translations.json'

export function getImageUrl(disaster) {
  if (!translations[disaster]) {
    return `${process.env.PUBLIC_URL}/images/generic.png`
  }

  const imageName = disaster.trim().replace(/ /g, '-').toLowerCase()
  return `${process.env.PUBLIC_URL}/assets/images/${imageName}.png`
}
